<!-- 产品-设备重复详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片-设备重复详情表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form" style="max-width: 680px; align-items: center;">
            <!-- 表单-日期范围选择-创建时间 -->
            <div class="table-search-form-flex">
              <div class="table-search-form-box" style="width: 350px;">
                <el-date-picker :picker-options="pickerOptions" v-model="searchForm.date" class="md-date-form-item" align="left" type="datetimerange" range-separator="~" prefixIcon="no" :clearable="true" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
              </div>
            </div>
            <!-- 表单-按钮 (只在小屏幕模式下显示) -->
            <div class="md-layout-item" style="max-width:300px;display: flex;">
              <md-button class= "left-icon md-info" @click="form_changeSearchData" style="max-width: 100px;">
                <md-icon>search</md-icon>{{$I18n("search")}}
              </md-button>
              <!-- <md-button class= "left-icon md-info" @click="form_addFile" v-if="UserInfo.auth_limit" style="max-width: 100px;">
                <md-icon>add</md-icon>{{$I18n("add")}}
              </md-button> -->
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-表格
           -->
          <md-table v-model="tableData">
            <!-- 批次ID  授权类型   云平台类型 附件 授权时间 授权总数 授权成功 授权失败  操作 -->
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('batch_id')">{{ item.batch_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('auth_type')">{{ item.auth_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cloud_plat_type')">{{ item.sys_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('attach')">
                <a :href="item.file_url" download style="color: #00bcd4;">{{ 
                  item.file_url.split("_").pop()
                }}</a>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('apply_time')">{{ item.create_date }}</md-table-cell>
              <md-table-cell :md-label="$I18n('appr_time')">{{ item.state != 9 ?item.approval_date : "-" }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">
                <span :class="{
                  'succ-span': item.state == 2,
                  'fail-span': item.state != 1 && item.state != 2 && ![9,10,11].includes(item.state),
                }">
                  {{ item.state_name }}
                </span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('auth_total')">{{ item.auth_count ?item.auth_count :0 }}</md-table-cell>
              <md-table-cell :md-label="$I18n('auth_succ')">
                <span v-if="item.state == 9">-</span>
                <span v-else :class="item.auth_suc && item.auth_suc > 0 ?'succ-span' :''">{{ item.auth_suc?item.auth_suc:0 }}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('auth_fail')">
                <span v-if="item.state == 9">-</span>
                <span v-else :class="item.auth_fail && item.auth_fail > 0 ?'fail-span' :''">{{ item.auth_fail?item.auth_fail:0 }}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('appr_com')">
                <el-tooltip v-if="item.state_msg&&item.state_msg.length > 5" class="item" :content="item.state_msg" placement="top">
                  <span>
                    {{item.state_msg.slice(0,5)+"..."}}
                    </span>
                </el-tooltip>
                <span v-else>{{item.state_msg}}</span>
              </md-table-cell>

              <md-table-cell :md-label="$I18n('operate')" class="button-cell table-operate">
                <template v-if="UserInfo.role_id <= 10000">
                  <md-button @click="() => openAgree(item)" :class="{
                    'md-disabled': item.state != 9,
                    'md-info': item.state == 9,
                  }" class=" md-simple md-table-md-button" style="margin-right: 10px;">
                    {{$I18n("agree")}} 
                  </md-button>
                  <md-button @click="() => openReject(item)" :class="{
                    'md-disabled': item.state != 9,
                    'md-info': item.state == 9,
                  }" class="md-simple md-table-md-button" style="margin-right: 10px;">
                    {{$I18n("reject")}}
                  </md-button>
                </template>
                <md-button @click="() => openDetail(item)" class="md-simple md-info md-table-md-button" style="margin-right: 10px;">
                  {{$I18n("view_det")}}
                </md-button>
                <!-- 正常下载 -->
                <a v-if="item.result_url" :href="`${item.result_url}`">
                  <md-button class="md-simple md-info md-table-md-button">
                    {{$I18n("dl")}}
                  </md-button>
                </a>
                <!-- 修改名称的文件下载 -->
                <!-- <md-button v-if="item.result_url" @click="() => downloadAliFile(item.result_url, item.dl_name)" class="md-simple md-info md-table-md-button">
                  {{$I18n("dl")}}
                </md-button> -->
                <md-button v-else @click.stop class="md-simple md-disabled md-table-md-button" >
                  {{$I18n("dl")}}
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data_02")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page-v2 :showTotal="true" :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
      </md-card>
    </div>
    

    <simple-modal ref="modal_agree" :title="$I18n('appr')" @submit="setAgree">
      <div slot="body">{{$I18n("check_agree")}}</div>
    </simple-modal>
    <simple-modal ref="modal_reject" :title="$I18n('appr')" @submit="setReject">
      <div slot="body">
        <label style="text-align: left;width: 100%;display: inline-block;">{{$I18n('reject_reason').replace('%s%', apprMsg.length)}}</label>
        <el-input
          type="text"
          placeholder=""
          v-model="apprMsg"
          maxlength="50"
          style="border-bottom: 1px solid #AAA;"
        />
      </div>
    </simple-modal>
    <simple-modal 
      class  = "big-title"
      ref    = "modal_d"
      :title = "$I18n('details')"
      :right = "true"
      :large = "true"
      :submitBtn="false"
      @click="hideSelectOptions"
    >
      <div slot="body" style="text-align: left;">
        <div style="display: flex;align-items: center;">
          <h3 class="modal-h3">{{$I18n("datacenter")}}</h3>
        </div>
        <div style="text-align: left;padding-right: 35px;padding-left: 10px;">
          <md-button class="left-icon md-info none-shadow" style="width: 100px;margin-left:0;" @click="getLicDetail_data">
            <md-icon>refresh</md-icon>{{$I18n("refresh")}}
          </md-button>
        </div>
        <md-table v-model="detailsDatas_table">
          <!-- 批次ID  授权类型   云平台类型  授权时间 授权总数 授权成功 授权失败  操作 -->
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="$I18n('srv_ip')">{{ item.srv_ip }}</md-table-cell>
            <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('auth_total')">{{ item.auth_count?item.auth_count:0 }}</md-table-cell>
            <md-table-cell :md-label="$I18n('auth_succ')">
              <span :class="item.auth_suc && item.auth_suc > 0 ?'succ-span' :''">{{ item.auth_suc?item.auth_suc:0 }}</span>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('auth_fail')">
              <span :class="item.auth_fail && item.auth_fail > 0 ?'fail-span' :''">{{ item.auth_fail?item.auth_fail:0 }}</span>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('latest_timestamp')">{{ item.updated_date }}</md-table-cell>
            <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.created_date }}</md-table-cell>
            <!-- </md-table-cell> -->
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data_02")}} </md-table-empty-state>
        </md-table>

        <div style="width:100%; height: 80px;"></div>
        <div style="display: flex;align-items: center;">
          <h3 class="modal-h3">{{$I18n("auth_detail")}}</h3>
        </div>
        <div class="md-layout card-form" style="display: flex;align-items: center;">
          <!-- Label -->
          <div class="table-search-form-flex label-type">
            <div class="table-search-form-label" style="padding-left: 10px; ">
              {{$I18n("auth_status")}}
            </div>
          </div>
          <!-- 授权状态：成功/失败 -->
          <div class="table-search-form-flex" style="max-width: 120px;margin-right: 20px;">
            <div class="table-search-form-box">
              <el-select ref="search_select_01" v-model="modalSeachForm.auth_state">
                <el-option :value="1" :label="$I18n('is_succ')" />
                <el-option :value="2" :label="$I18n('is_fail')" />
              </el-select>
            </div>
          </div>
          <!-- 授权状态：UID/SN 二选一 -->
          <div class="table-search-form-flex" style="max-width: 120px;">
            <div class="table-search-form-box">
              <el-select ref="search_select_02" v-model="modalSeachFormType">
                <el-option :value="1" :label="'UID'" />
                <el-option :value="2" :label="'SN'" />
              </el-select>
            </div>
          </div>
          <!-- UID/SN -->
          <div class="table-search-form-flex" style="max-width: 200px;margin-right: auto;">
            <div class="table-search-form-box">
              <el-input v-if="modalSeachFormType == 1" v-model="modalSeachForm.uid"/>
              <el-input v-if="modalSeachFormType == 2" v-model="modalSeachForm.sn"/>
            </div>
          </div>

          <!-- 表单-按钮 (只在小屏幕模式下显示) -->
          <div class="md-layout-item" style="max-width:300px;display: flex;">
            <md-button class= "left-icon md-info none-shadow" @click="searchDetail_dev">
              <md-icon>search</md-icon>{{$I18n("search")}}
            </md-button>
            <md-button class= "left-icon none-shadow hollow-button" @click="resetDetailForm">
              <md-icon>refresh</md-icon>{{$I18n("reset")}}
            </md-button>
          </div>
        </div>
        <md-table v-model="detailsDevs_table">
          <!-- 批次ID  授权类型   云平台类型  授权时间 授权总数 授权成功 授权失败  操作 -->
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="$I18n('uid_code')">{{ item.uid }}</md-table-cell>
            <md-table-cell :md-label="$I18n('dev_snid')">{{ item.sn }}</md-table-cell>
            <md-table-cell :md-label="$I18n('auth_res')">
              <span :class="{
                'succ-span': item.auth_state == 1,
                'fail-span': item.auth_state != 1,
              }">{{ item.state_name }}</span>
            </md-table-cell>
            <md-table-cell :md-label="$I18n('auth_date')">{{ item.auth_date }}</md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data_02")}} </md-table-empty-state>
        </md-table>
        <table-page-v2 :showTotal="true" :total="dev_total" :pageSize="dev_page_size" @changePage="page => dev_page_size = page" v-model="dev_page_no"/>
      </div>

    </simple-modal>
  </div>
</template>
<script>
import { timestampToString1000, nDaysAgo, timestampToString/* nMonthsAgo,  */ } from "@/common/tools.js";
// import FileInput from "@/components/Common/FileInput.vue";

export default {
  components: {
    // FileInput,
  },
  props:["userinfo_sys"],
  data() {
    const todayEnd = nDaysAgo(0) + " 23:59:59";
    return {
      pickerOptions: { // 时间范围选择
        disabledDate(time) {
          return time.getTime() > new Date(todayEnd);
        },
      },
      searchForm : { // 表单-筛选表格的查询表单
        date    : undefined,
      },
      searchData : { // API-筛选表格的查询数据
        gmt_start : 0,
        gmt_end   : 0,
      },
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize    : 10,
      currentPage : 1,
      total       : 0,


      //
      detailsItem  : {},
      detailsDatas : [],
      detailsDevs  : [],
      dev_page_no  : 1,
      dev_page_size: 10,
      dev_total    : 0,
      modalSeachFormType: 1, // 查询uid(1)还是sn(2)
      modalSeachForm: {
        uid:"",
        sn :"",
        auth_state:1,
      },
      modalSeachData: {
        uid:"",
        sn :"",
        auth_state:1,
      },

      apprData:{},
      apprMsg: "",
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    modalSeachFormType(){
      this.modalSeachForm.uid = "";
      this.modalSeachForm.sn = "";
    },
    currentPage() {
      this.api_getPageData();
    },
    pageSize(){
      if(this.currentPage != 1){
        this.currentPage = 1;
      } else {
        this.api_getPageData();
      }
    },
    dev_page_no(){
      this.getLicDetail_dev();
    },
    dev_page_size(){
      if(this.dev_page_no != 1){
        this.dev_page_no = 1;
      } else {
        this.getLicDetail_dev();
      }
    },
  },
  methods: {
    async downloadAliFile(dl_url, dl_name) {
      // 1. 你的阿里云文件地址
      const fileUrl = dl_url;

      // 2. 你想要的新文件名（必须带后缀）
      const newFileName = dl_name;

      try {
        // 3. 核心：下载为Blob，本地重命名
        const response = await fetch(fileUrl);
        const blob = await response.blob();

        // 4. 生成本地临时URL
        const tempUrl = window.URL.createObjectURL(blob);

        // 5. 创建a标签下载 + 改名
        const a = document.createElement("a");
        a.href = tempUrl;
        a.download = newFileName; // 强制改名
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // 释放内存
        setTimeout(() => window.URL.revokeObjectURL(tempUrl), 200);
      } catch (err) {
        alert("下载失败");
        console.log(err);
      }
    },

    strTotime(str){
      if(!str){
        return 0
      }
      return new Date(str).getTime() / 1000
    },
    // 同意/拒绝弹窗
    openAgree(item){
      if(item.state == 9){
        this.apprData = {...item};
        this.$refs.modal_agree.open();
      }
    },
    setAgree(){
      this.$api.setLicAuth({
        id        :this.apprData.id,
        state_msg :"",
        state     :11,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("sub_succ_01"));
          this.$refs.modal_agree.close();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("sub_fail_01")))
    },
    openReject(item){
      if(item.state == 9){
        this.apprData = {...item};
        this.apprMsg = "";
        this.$refs.modal_reject.open();
      }
    },
    setReject(){
      if(!this.apprMsg){
        this.$errorMsg(this.$I18n("pls_input_text"))
        return
      }
      this.$api.setLicAuth({
        id        :this.apprData.id,
        state_msg :this.apprMsg,
        state     :10,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("sub_succ_01"));
          this.$refs.modal_reject.close();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("sub_fail_01")))
    },
    // 详情弹窗用
      hideSelectOptions(){
        if(this.$refs.search_select_01){
          this.$refs.search_select_01.blur();
          this.$refs.search_select_02.blur();
        }
      },
      openDetail(item){
        this.detailsItem = {...item};
        this.resetDetailForm();
        this.modalSeachData = {...this.modalSeachForm};
        this.dev_page_no = 1;
        this.getLicDetail_dev(true)
          .then(() => {
            this.$refs.modal_d.open();
          })
      },
      getLicDetail_data(){
        return this.$api.getLicAuthDetail({
          id: this.detailsItem.id,
        })
          .then(res => {
            if(res.data && res.data.datas && res.data.datas.length > 0){
              this.detailsDatas = res.data.datas
            } else {
              this.detailsDatas = []
            }
          })
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.detailsDatas = [];
          }))
      },
      getLicDetail_dev(getdata){
        console.log("!>")
        return this.$api.getLicAuthDetail({
          ...this.modalSeachData,
          id: this.detailsItem.id,
          page_no: this.dev_page_no,
          page_size: this.dev_page_size,
        })
          .then(res => {
            if(res.data && res.data.dev_count && res.data.dev_count > 0){
              this.detailsDevs = res.data.devs;
            } else {
              this.detailsDevs = [];
            }
            this.dev_total = res.data.dev_count ?res.data.dev_count :0;
            // if(this.modalSeachData.uid != "" || this.modalSeachData.sn != ""){
            //   this.dev_total = res.data.dev_count ?res.data.dev_count :0;
            // } else {
            //   this.dev_total = this.modalSeachData.auth_state == 1 
            //     ?(res.data.auth_suc ?res.data.auth_suc :0)
            //     :(res.data.auth_fail?res.data.auth_fail:0)
            // }
            if(getdata){
              if(res.data && res.data.datas && res.data.datas.length > 0){
                this.detailsDatas = res.data.datas
              } else {
                this.detailsDatas = []
              }
            }
          })
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.detailsDevs = [];
            this.dev_total = 0;
            if(getdata){
              this.detailsDatas = []
            }
          }))
      },
      resetDetailForm(){
        this.modalSeachForm = {
          uid:"",
          sn :"",
          auth_state:1,
        }
      },
      searchDetail_dev(){
        this.modalSeachData = {...this.modalSeachForm};
        if(this.dev_page_no != 1){
          this.dev_page_no = 1;
        } else {
          this.getLicDetail_dev();
        }
      },

    // 表格用
      api_getPageData(){ // API-获取页面信息
        // 获取角色
        this.$api.getLicAuth({
            ...this.searchData,
            page_size: this.pageSize,
            page_no: this.currentPage,
        })
          .then(this.$Then(res => {
            this.total = res.count;
            this.tableInitData = res.data.map(item => {
              return {
                ...item,
                ver: item.ver ?item.ver :"",
              };
            });
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.total = 0;
            this.tableInitData = [];
          }))
      },
      // 更改查询条件(并立刻查询)
      form_changeSearchData () {
        if(this.searchForm.date){
          this.searchData = {
            gmt_start : this.searchForm.date[0]?this.strTotime(this.searchForm.date[0]) :0,
            gmt_end  : this.searchForm.date[1]?this.strTotime(this.searchForm.date[1]) :0,
          };
        } else {
          this.searchData = {
            gmt_start : 0,
            gmt_end  : 0,
          };
        }
        if(this.currentPage != 1){
          this.currentPage = 1;
        } else {
          this.api_getPageData();
        }
      },
  },
  computed: {
    detailsDevs_table(){
      return this.detailsDevs.map(item => {
        return {
          ...item,
          state_name: this.$I18n(this.$Param.licDevState.getName(item.auth_state, "unknow")),
          auth_date: timestampToString1000(item.gmt_auth),
        }
      })
    },
    detailsDatas_table(){
      return this.detailsDatas.map(item => {
        const state_name = this.$I18n(this.$Param.licDataState.getName(item.state, "unknow"));
        return {
          ...item,
          state_name,
          updated_date: timestampToString(new Date(item.updated_at).getTime()),
          created_date: timestampToString(new Date(item.created_at).getTime()),
        }
      })
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          // 状态
          let state_name = this.$I18n('unknow')
          switch(item.state){
            case "1":
            case 1:
              state_name = this.$I18n("pending");
              break;
            case "2":
            case 2:
              state_name = this.$I18n("done_succ");
              break;
            case "3":
            case 3:
              state_name = this.$I18n("fail_num");
              break;
            case "4":
            case 4:
              state_name = this.$I18n("auth_less");
              break;
            case "5":
            case 5:
              state_name = this.$I18n("file_load_timeout");
              break;
            case "6":
            case 6:
              state_name = this.$I18n("file_load_fail");
              break;
            case "7":
            case 7:
              state_name = this.$I18n("no_lic_id");
              break;
            case "8":
            case 8:
              state_name = this.$I18n("auth_limit_exc");
              break;
            case "9":
            case 9:
              state_name = this.$I18n("no_audited");
              break;
            case "10":
            case 10:
              state_name = this.$I18n("rev_rej");
              break;
            case "11":
            case 11:
              state_name = this.$I18n("audit_pass");
              break;
          }
          let dl_name = "";
          if(item.result_url){
            const split_file_name = item.result_url.split('_');
            if(split_file_name.length > 1){
              dl_name = split_file_name.pop();
            } else {
              dl_name = split_file_name[0].split("/").pop();
            }
          }
          return {
            dl_name,
            state_name,
            // type_name,
            auth_name: item.auth_type == 1 ?this.$I18n("uid_auht") :"",
            create_date: timestampToString1000(item.gmt_create),
            update_date: timestampToString1000(item.gmt_update),
            approval_date: timestampToString1000(item.gmt_approval),
            ... item,
          }
        })
      }
    },
  },
}
</script>
<style lang="css" scoped>
  .succ-span{
    color: rgb(118,176,79);
  }
  .fail-span{
    color: rgb(255,19,19);
  }
  h3.modal-h3, .big-title /deep/ .modal-title{
    margin: 0 20px 5px 10px;
    font-size: 25px;
    font-weight: 600;
    color: rgb(60, 72, 88);
    line-height: 1.4em;
  }


  /deep/ .md-table-fixed-header-active{
    border: none !important;
  }
  /deep/ .modal-mask.lg-modal.rigth-modal.big-modal{
    z-index: 1000 !important;
  }
  .md-table-md-button /deep/ .md-ripple{
    padding: 0 !important;
  }
  .md-table-md-button {
    padding: 0 !important;
    margin-right: 5px;
  }
  .md-table-md-button.md-disabled {
    cursor: not-allowed !important;
  }
  button.left-icon /deep/ i{
    color: #FFFFFF !important;
  }
  button.left-icon.hollow-button /deep/ i{
    color: rgb(0, 188, 212) !important;
  }
  button.left-icon{
    background: #00bcd4;
    border: none;
    color: #FFFFFF;
    border-radius: 4px;
    line-height: 36px;
    height: 36px;
    padding: 0 20px 0 15px;
    cursor: pointer;
  }
</style>
<style lang="scss" scoped>

  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 60px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>
